/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TheCargo Shipment
 * Core logistics engine for managing vehicle shipments from lead intake to final delivery.

## Shipment Lifecycle

Every shipment progresses through three stages:

| Stage | Description |
|-------|-------------|
| `lead` | Initial inquiry — vehicle and route info collected |
| `quote` | Price quoted to the customer |
| `order` | Confirmed order dispatched to a carrier |

Use `POST /api/v1/shipments/{id}/convert` to advance a shipment between stages.

## Authentication

All endpoints require a JWT Bearer token:
```
Authorization: Bearer <access_token>
```

Obtain tokens via the **Auth Service** (`POST /auth/api/v1/auth/login`).

## Contact

For API access or issues contact **support@thecargo.io**
 * OpenAPI spec version: 1.0.0
 */

export type StopType = (typeof StopType)[keyof typeof StopType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StopType = {
  pickup: 'pickup',
  delivery: 'delivery',
} as const
